import React from "react";
import ReactPlayer from "react-player";
function CardCursoVideoInicioComponent({ curso }) {
  return (
    <div className="field col-12 md:col-5 card__video_intro_responsive" >
      <div className=" rounded-9 shadow ">
        <div className="row g-2 mb-2 align-items-center card__contenedor_video">
          <div className="rounded-10 p-md-4 mb-md-4 title__video__intro__contenedor">
            <span className="title__video__intro " data-v-48f3e599="" style={{marginLeft: "8px"}}>
              ¿Cómo utilizar la plataforma? Mira el siguiente video.
            </span>
          </div>
          <div className="video_intro">
            {curso && (
              <ReactPlayer
                url={"https://vimeo.com/" + curso.videoIntroduccion}
                width="100%"
                height={"100%"}
                controls={true}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardCursoVideoInicioComponent;
